import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles, useTheme } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import H1 from '../../components/header1';
import {
  FirstTab,
  SecondTab,
  ThirdTab,
  FourthTab,
} from '../../components/sustainabilityTabs';
import { TabMenu, TabPanel } from '../../components/Tabs';
import { SUB_PAGES } from '../../utils/constants';
import { isBrowser } from '../../utils/functions';

const useStyles = makeStyles({
  header: {
    '@media (max-width:600px)': {
      fontSize: 12,
    },
  },
  tabPanelStyle: {
    margin: '40px 0 0',
  },
});

const { titles, sustainabilityTabs } = SUB_PAGES.SUSTAINABILITY;

const getIndexFromPathName = pathname => {
  const index = sustainabilityTabs.findIndex(
    element => element.tabLink === pathname
  );
  return index !== -1 ? index : 0;
};

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const location = isBrowser() && window.location.pathname;
  const [selectedTab, setSelectedTab] = useState(
    getIndexFromPathName(location)
  );

  const handleChange = (_, index) => {
    setSelectedTab(index);
    const urlToPush = sustainabilityTabs[index].tabLink;
    if (isBrowser()) {
      window.history.pushState(null, null, urlToPush);
    }
  };

  const handleChangeIndex = index => {
    setSelectedTab(index);
  };

  useEffect(() => {
    if (isBrowser) {
      setSelectedTab(getIndexFromPathName(window.location.pathname));
    }
  });

  return (
    <Container maxWidth="xl" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <Grid container direction="column">
        <Grid item>
          <Container maxWidth="xl" className={classes.header}>
            <H1 title="SUSTAINABILITY" />
          </Container>
        </Grid>
        <TabMenu value={selectedTab} onChange={handleChange} tabs={titles} />
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={selectedTab}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel
            value={sustainabilityTabs[0].tabValue}
            currentValue={selectedTab}
            className={classes.tabPanelStyle}
          >
            <FirstTab />
          </TabPanel>
          <TabPanel
            value={sustainabilityTabs[1].tabValue}
            currentValue={selectedTab}
            className={classes.tabPanelStyle}
          >
            <SecondTab />
          </TabPanel>
          <TabPanel
            value={sustainabilityTabs[2].tabValue}
            currentValue={selectedTab}
            className={classes.tabPanelStyle}
          >
            <ThirdTab />
          </TabPanel>
          <TabPanel
            value={sustainabilityTabs[3].tabValue}
            currentValue={selectedTab}
            className={classes.tabPanelStyle}
          >
            <FourthTab />
          </TabPanel>
        </SwipeableViews>
      </Grid>
    </Container>
  );
};

export default Index;
